import React, { useEffect, useState } from 'react';
import api from '../api';
import { useParams, useNavigate } from 'react-router-dom';
import AttendeeForm from '../components/AttendeeForm';

export default function RsvpPage() {
  const { token } = useParams();
  const [event, setEvent] = useState(null);
  const [attendees, setAttendees] = useState([{ name: '', email: '', phone: '' }]);
  const navigate = useNavigate();

  useEffect(() => {
    if (token && token.startsWith('event-')) {
      const id = token.split('event-')[1];
      api.get(`/events/${id}/`).then(r => setEvent(r.data));
      return;
    }
  }, [token]);

  const handleChange = (idx, field, value) => {
    const clone = [...attendees];
    clone[idx][field] = value;
    setAttendees(clone);
  };
  const addAttendee = () => setAttendees(prev => [...prev, { name: '', email: '', phone: '' }]);
  const removeAttendee = (idx) => setAttendees(prev => prev.filter((_, i) => i !== idx));

  const submit = async () => {
    if (!event) return alert('No event loaded');
    try {
      const payload = { entries: attendees };
      await api.post(`/events/${event.uuid}/rsvp/`, payload);
      navigate('/invitation');
    } catch (e) {
      console.error(e);
      alert('Failed to submit');
    }
  };

  if (!event) return <div>Loading event...</div>;

  return (
    <div className="container">
      <h2 className="rsvp-header">RSVP for {event.name}</h2>
      <p>{event.description}</p>
      {attendees.map((a, i) => (
        <AttendeeForm key={i} index={i} attendee={a} onChange={handleChange} onRemove={removeAttendee} />
      ))}
      <button onClick={addAttendee}>Add More</button>
      <div style={{ marginTop: 12 }}>
        <button onClick={submit}>Submit RSVP</button>
      </div>

      {!localStorage.getItem('access') && (
        <div style={{
          marginTop: '40px',
          padding: '24px',
          background: 'rgba(99, 102, 241, 0.05)',
          borderRadius: '12px',
          textAlign: 'center',
          border: '1px dashed var(--primary)'
        }}>
          <h4 style={{ margin: '0 0 10px 0' }}>Want to manage your RSVP later?</h4>
          <p style={{ margin: '0 0 20px 0', fontSize: '14px', color: '#666' }}>
            Create an account to keep track of all your event invitations and manage your RSVPs.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
            <button className="secondary" onClick={() => navigate(`/signup?redirectTo=${encodeURIComponent(window.location.pathname)}`)}>
              Sign Up
            </button>
            <button className="secondary" onClick={() => navigate(`/login?redirectTo=${encodeURIComponent(window.location.pathname)}`)}>
              Log In
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
